import { Form } from "antd";
import { FC, ComponentType } from "react";
import FlightSelect from "../FlightSelect/FlightSelect";

type FlightSelectContentProps = {
  name: string;
  rules: any[];
  dependencies?: string[];
  label: string;
  icon: ComponentType<{ className?: string }>;
  className?: string;
  closeSheet?: () => void;
};

const FlightSelectContent: FC<FlightSelectContentProps> = ({ name, rules, dependencies, label, icon, className, closeSheet }) => {

  return (
    <Form.Item
      name={name}
      dependencies={dependencies}
      className="m-0! focus-within:ring-0! w-full font-semibold md:flex-1 md:border-none [&_.ant-form-item-explain-error]:hidden [&_.ant-form-item-explain-error]:md:block"
      rules={rules}
    >
      <FlightSelect label={label} icon={icon} className={className} closeSheet={closeSheet} />
    </Form.Item>
  );
};

export default FlightSelectContent;